function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M0 0h24v24H0z"
}), /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24,
  fill: "#4E2E7F",
  rx: 2.462
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  fillRule: "nonzero",
  d: "M4.306 18.136c1.28.598 2.56 1.21 3.84 1.822.056.042.153.042.223.042h2.921c.167 0 .195-.056.195-.209-.014-.862 0-1.725 0-2.588 0-.055-.014-.083-.014-.166-.07.041-.139.055-.194.083-.89.39-1.81.71-2.81.584-.39-.055-.738-.18-1.03-.459-.515-.487-.654-1.127-.668-1.795-.014-.556.041-1.113.111-1.67.07-.653.237-1.28.515-1.877.737-1.628 1.822-3.02 3.102-4.244.418-.403.919-.723 1.392-1.085.111-.084.222-.084.348 0 .375.278.765.529 1.113.82a13.85 13.85 0 0 1 2.337 2.686c.682.988 1.252 2.045 1.475 3.242.167.876.278 1.767.125 2.657-.223 1.197-.932 1.711-2.004 1.74-.528.013-1.043-.098-1.544-.279-.362-.125-.723-.278-1.085-.417v2.699c0 .18.056.222.236.222.947-.014 1.879 0 2.825-.014.125 0 .25-.041.362-.083 1.238-.584 2.476-1.183 3.7-1.767.25-.125.25-.111.181-.39-.695-2.727-1.377-5.44-2.073-8.167a.652.652 0 0 0-.153-.264c-.278-.278-.57-.542-.849-.807-.542-.5-1.085-1.002-1.641-1.502-.738-.668-1.461-1.322-2.199-2.004-.278-.264-.584-.529-.862-.807-.098-.083-.167-.083-.264.014-.126.125-.265.237-.39.348-.57.529-1.14 1.057-1.711 1.572-.613.557-1.21 1.113-1.837 1.67l-1.336 1.21c-.166.167-.375.306-.445.57-.681 2.714-1.363 5.44-2.059 8.154-.028.292 0 .39.167.459z"
}));

var SvgIcScb = function SvgIcScb(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    style: {
      background: "#fff"
    },
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcScb, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic_scb.e857b4e4.svg";
export { ForwardRef as ReactComponent };